import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

orderDetailsButtonSetStyles.buttonsWrapper = mergeToNew(orderDetailsButtonSetStyles.buttonsWrapper, {
    css: css`
        button {
            border-color: ${getColor("primary")};
            padding: 10px 34px;
            border-radius: 0;
            color: ${getColor("primary.contrast")} !important;
            span {
                color: ${getColor("primary.contrast")};
                font-weight: ${TYPOGRAPHY.weight.base} !important;
                font-size: ${TYPOGRAPHY.size.smaller} !important;
                line-height: ${TYPOGRAPHY.lineHeight.base} !important;
            }

            :hover {
                color: ${getColor("primary.contrast")} !important;
                background: ${getColor("text.accent")};
                border-color: ${getColor("text.accent")} !important;
            }
        }
        nav[class^="OverflowWrapper"] {
            margin-right: 27px;
            > button {
                background-color: ${getColor("primary.contrast")};
                border: 0;
            }
            ul li button {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
});

orderDetailsButtonSetStyles.tabletMenuHidden = mergeToNew(orderDetailsButtonSetStyles.buttonWrapper, {
    css: css`
        display: flex;
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                null,
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
            ])};
    `,
});

orderDetailsButtonSetStyles.buttonWrapper = mergeToNew(orderDetailsButtonSetStyles.buttonWrapper, {
    css: css`
        margin-left: 10px;
    `,
});
orderDetailsButtonSetStyles.printButton = mergeToNew(orderDetailsButtonSetStyles.printButton, {
    variant: "secondary",
    css: css`
        border-color: ${getColor("text.main")};
        color: ${getColor("primary.contrast")} !important;
        background: transparent;
        > span {
            color: ${getColor("text.main")} !important;
        }
        &:hover {
            opacity: 0.3;
            background: none !important;
            color: ${getColor("primary.contrast")} !important;
            border-color: ${getColor("text.main")} !important;
            > span {
                color: 1px solid ${getColor("primary")};
            }
        }
    `,
});
orderDetailsButtonSetStyles.cancelButton = mergeToNew(orderDetailsButtonSetStyles.cancelButton, {
    variant: "secondary",
    css: css`
        border-color: ${getColor("text.main")};
        color: ${getColor("primary.contrast")} !important;
        background: transparent;
        > span {
            color: ${getColor("text.main")} !important;
        }
        &:hover {
            opacity: 0.3;
            background: none !important;
            color: ${getColor("primary.contrast")} !important;
            border-color: ${getColor("text.main")} !important;
            > span {
                color: 1px solid ${getColor("primary")};
            }
        }
    `,
});
orderDetailsButtonSetStyles.rmaButton = mergeToNew(orderDetailsButtonSetStyles.rmaButton, {
    variant: "primary",
    css: css`
        border-color: ${getColor("text.main")};
        color: ${getColor("primary.contrast")} !important;
        background: ${getColor("primary")};
        > span {
            color: ${getColor("primary.contrast")} !important;
        }
        &:hover {
            background: ${getColor("text.accent")} !important;
            color: ${getColor("primary.contrast")} !important;
            border-color: ${getColor("text.accent")} !important;
            > span {
                color: ${getColor("primary.contrast")};
            }
        }
    `,
});
